export default __webpack_public_path__ + "static/ejXYawTT-1a7fb6e183c20733670b148f3d17e6fa.svg";